import {
  getDeviceId,
  getSessionId,
  Identify,
  identify,
  init,
  setUserId,
  track,
} from '@amplitude/analytics-browser';

import AmplitudeExperiment from 'common/services/amplitude/experiment';

import { trackEvents } from 'common/config/events';
import { Dictionary } from 'common/types/global';
import { Error, EventProps, TrackerConfig, TrackerEvent, UserEvent } from 'common/types/services';
export interface UserPropsObject {
  [k: string]: string;
}

export type EventPropsAmplitude = Dictionary<string | number | boolean | Array<string>>;

class AmplitudeTracker extends TrackerEvent {
  valid = (key: keyof TrackerConfig) => {
    return trackEvents.amplitude.enabled && trackEvents.amplitude[key];
  };

  init = async () => {
    if (this.valid('enabled')) {
      await init(process.env.REACT_APP_AMPLITUDE_KEY || '', undefined, {
        appVersion: process.env.REACT_APP_VERSION ?? '0.0.0',
      }).promise;
      await AmplitudeExperiment.init();
      window.amp = {
        deviceId: getDeviceId() ?? '',
        sessionId: (getSessionId() ?? '')?.toString(),
      };
    }
  };
  trackUser = (user: UserEvent) => {
    if (this.valid('user')) {
      setUserId(user.id_external);
    }
  };

  setUserProps = (userProps: Partial<UserPropsObject>) => {
    try {
      const identifyObj = new Identify();
      Object.entries(userProps).forEach(([key, value]) => {
        if (value) {
          identifyObj.set(key, value);
        }
      });

      identify(identifyObj);
    } catch {}
  };

  trackError = (error: unknown) => {
    if (this.valid('event')) {
      track('Error Encountered', {
        Source: window.location.hostname,
        'Error Name': (error as Error).error,
        'Error Description': (error as Error).description,
        'Error Type': 'Frontend',
        'Product Type': 'OT',
      });
    }
  };

  trackEvent = (eventName: string, props?: EventProps) => {
    if (this.valid('event')) {
      const eventOptions = {
        time: Date.now(),
      };
      track(eventName, props, eventOptions);
    }
  };

  trackUniqueEvent = (eventName: string, insertId: string, props?: EventProps) => {
    if (this.valid('event')) {
      const eventOptions = {
        time: Date.now(),
        insert_id: insertId,
      };
      track(eventName, props, eventOptions);
    }
  };
}

export default new AmplitudeTracker();
